<!--
 * @Author: shiao
 * @Date: 2020-12-23 09:05:04
 * @LastEditTime: 2020-12-23 09:19:13
 * @Description: 居中透明背景loading
 * @LastEditors: shiao
 * @FilePath: \health-h5\src\components\fullscreen-loading.vue
-->
<template>
  <div class="part-loading-body">
    <van-overlay :show="loading" @click="show = false" z-index="8">
      <div class="loading-div">
        <van-loading type="spinner" size="26px" color="#fff"></van-loading>
        <div class="loading-text">{{text}}</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  export default {
    name: 'partLoading',
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      text: {
        type: String,
        default: '加载中...'
      }
    }
  }
</script>

<style lang='less' scoped>
  .part-loading-body {
    .van-overlay {
      background-color: transparent;
    }

    .loading-div {
      width: 100px;
      height: 100px;
      position: relative;
      text-align: center;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
      background: rgba(17, 17, 17, 0.3);
      border-radius: 5px;
      opacity: 0.7;
      overflow: hidden;

      .van-loading {
        margin-top: 30%;
      }

      .loading-text {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        margin-top: 10px;
      }
    }

  }
</style>